exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.game-header {\n  height: 35px;\n  width: 100%;\n  line-height: 35px;\n  background-color: #22252A;\n  text-align: left;\n  color: #fff;\n  font-size: 0.9rem;\n  padding-left: 35px;\n}\n.game-round,\n.game-countdown {\n  color: #fff;\n  font-weight: bold;\n  font-size: 1em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2199ce5b","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shop/main/GameHeader.vue
// module id = 294
// module chunks = 0